import { render } from "./CardLoaderSmall.vue?vue&type=template&id=b715f532"
import script from "./CardLoaderSmall.vue?vue&type=script&lang=js"
export * from "./CardLoaderSmall.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__